import { useState, useEffect, useRef } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { HardHat, CheckCircle2, AlertCircle, Loader2 } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    if (!token) { setState("error"); setMessage("Ongeldige of onvolledige bevestigingslink."); return; }
    api.post("/auth/verify-email", { token })
      .then(({ data }) => { setState("ok"); setMessage(data.message || "Je e-mailadres is bevestigd."); })
      .catch((err) => { setState("error"); setMessage(formatApiErrorDetail(err.response?.data?.detail) || "Bevestigen mislukt."); });
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
      <div className="w-full max-w-md text-center" data-testid="verify-email-page">
        <Link to="/" className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-8 h-8 bg-orange-500 flex items-center justify-center rounded-sm"><HardHat className="w-4 h-4 text-white" /></div>
          <span className="font-display font-extrabold">Work4you</span>
        </Link>
        {state === "loading" && (
          <div data-testid="verify-loading"><Loader2 className="w-8 h-8 text-orange-500 animate-spin mx-auto mb-4" /><p className="text-slate-600">Bezig met bevestigen...</p></div>
        )}
        {state === "ok" && (
          <div data-testid="verify-success">
            <div className="w-14 h-14 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-5"><CheckCircle2 className="w-7 h-7 text-green-600" /></div>
            <h1 className="font-display text-3xl font-extrabold text-slate-950 mb-3">E-mail bevestigd</h1>
            <p className="text-sm text-slate-600 mb-6">{message}</p>
            <Link to="/inloggen" data-testid="verify-to-login" className="inline-block bg-orange-500 hover:bg-orange-600 text-white rounded-sm font-bold px-6 py-2.5">Inloggen</Link>
          </div>
        )}
        {state === "error" && (
          <div data-testid="verify-error">
            <div className="w-14 h-14 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-5"><AlertCircle className="w-7 h-7 text-red-600" /></div>
            <h1 className="font-display text-2xl font-extrabold text-slate-950 mb-3">Bevestigen mislukt</h1>
            <p className="text-sm text-slate-600 mb-6">{message}</p>
            <Link to="/inloggen" className="text-orange-600 font-semibold hover:underline text-sm">Naar inloggen</Link>
          </div>
        )}
      </div>
    </div>
  );
}
